// Discord webhook service for sending application notifications

// Discord Webhook Configuration
const DISCORD_WEBHOOK_URL = process.env.DISCORD_WEBHOOK_URL;

// Staff Channel Webhook Configuration
const STAFF_WEBHOOK_URL = process.env.STAFF_WEBHOOK_URL;

// Role IDs for pinging
const STAFF_ROLE_ID = '1380125200577990691';
const ADMIN_ROLE_ID = '1380125200577990693';

export const sendApplicationNotification = async (application, action) => {
  // Send Discord notification
  await sendDiscordNotification(application, action);
};

export const sendNewApplicationNotification = async (application) => {
  // Send staff notification for new application
  await sendStaffNotification(application);
};

// Discord Webhook Function
const sendDiscordNotification = async (application, action) => {

  const embed = {
    title: `Application ${action === 'approve' ? 'Approved' : 'Denied'}`,
    color: action === 'approve' ? 0x00ff00 : 0xff0000, // Green for approve, red for deny
    fields: [
      {
        name: 'Applicant',
        value: application.fullName,
        inline: true
      },
      {
        name: 'Discord Username',
        value: application.characterName,
        inline: true
      },
      {
        name: 'Department',
        value: application.department,
        inline: true
      },
      {
        name: 'Discord ID',
        value: application.discordId,
        inline: true
      },
      {
        name: 'Status',
        value: action === 'approve' ? '✅ Approved' : '❌ Denied',
        inline: true
      }
    ],
    timestamp: new Date().toISOString(),
    footer: {
      text: 'Skyline RP Application System'
    }
  };

  if (application.adminNotes) {
    embed.fields.push({
      name: 'Admin Notes',
      value: application.adminNotes,
      inline: false
    });
  }

  const webhookData = {
    content: `<@${application.discordId}> Your Skyline RP application has been ${action === 'approve' ? 'approved' : 'denied'}!`,
    embeds: [embed]
  };

  try {
    const response = await fetch(DISCORD_WEBHOOK_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(webhookData)
    });

    if (response.ok) {
      console.log('Discord notification sent successfully');
    } else {
      console.error('Failed to send Discord notification:', response.status);
    }
  } catch (error) {
    console.error('Error sending Discord notification:', error);
  }
};

// Staff Notification Function for New Applications
const sendStaffNotification = async (application) => {
  if (STAFF_WEBHOOK_URL === 'YOUR_STAFF_WEBHOOK_URL_HERE') {
    console.log('STAFF WEBHOOK (not configured):', {
      content: `<@&${STAFF_ROLE_ID}> <@&${ADMIN_ROLE_ID}> New application submitted!`,
      application: application
    });
    return;
  }

  const embed = {
    title: '🆕 New Application Submitted',
    color: 0x0099ff, // Blue color for new applications
    fields: [
      {
        name: '👤 Applicant',
        value: application.fullName,
        inline: true
      },
      {
        name: '🎭 Discord Username',
        value: application.characterName,
        inline: true
      },
      {
        name: '🏢 Department',
        value: application.department,
        inline: true
      },
      // {
      //   name: '📧 Email',
      //   value: application.email,
      //   inline: true
      // },
      {
        name: '🎮 Discord User ID',
        value: application.discordId,
        inline: true
      },
      {
        name: '📅 Age',
        value: application.age,
        inline: true
      }
    ],
    description: application.experience.length > 100 
      ? application.experience.substring(0, 100) + '...' 
      : application.experience,
    timestamp: new Date().toISOString(),
    footer: {
      text: 'Skyline RP Application System'
    }
  };

  const webhookData = {
    content: `<@&${STAFF_ROLE_ID}> <@&${ADMIN_ROLE_ID}> A new application has been submitted and requires review!`,
    embeds: [embed]
  };

  try {
    const response = await fetch(STAFF_WEBHOOK_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(webhookData)
    });

    if (response.ok) {
      console.log('Staff notification sent successfully');
    } else {
      console.error('Failed to send staff notification:', response.status);
    }
  } catch (error) {
    console.error('Error sending staff notification:', error);
  }
}; 